(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "../../utils/compose", "../../hoc/withDeviceSize", "../../modules/Auth", "./LoginButton"], b);else if ("undefined" != typeof exports) b(exports, require("../../utils/compose"), require("../../hoc/withDeviceSize"), require("../../modules/Auth"), require("./LoginButton"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.compose, a.withDeviceSize, a.Auth, a.LoginButton), a.index = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e) {
  "use strict";

  var f = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0, b = f(b), c = f(c), e = f(e);
  var g = (0, b.default)((0, c.default)(), (0, d.connectAuthProvider)("authenticated", "logoutAction"))(e.default);
  a.default = g;
});